"use strict";

/******************************************************
 *    Directive pour afficher les informations d'un élève
 ********************************************************/

angular.module("app").directive("tchUserProfile", function () {
	return {
		restrict: "E",
		templateUrl: "common/directives/tchUserProfile/tchUserProfile.html",
		replace: false,
		scope: {
			profil: "=tchUser"
		}
	};
})
;
